<!-- <ion-item lines="none" class="consent-grid"> -->
  <ion-grid lines="none" class="consent-grid">
    <ion-row>
      <ion-col size="4">
        <div class="display-grid">
          <ion-text class="child-item-label">{{ 'OPTED_IN_DATE' | translate }}</ion-text>
          <ion-label class="child-item-text">{{ optedInDate }}</ion-label>
        </div>
      </ion-col>
      <ion-col size="4">
        <div class="display-grid">
          <ion-text class="child-item-label">{{ 'OPTED_IN_SOURCE' | translate }}</ion-text>
          <ion-label class="child-item-text">{{ optedInSource }}</ion-label>
        </div>
      </ion-col>
      <ion-col size="4">
        <div class="channel-buttons-container">
          <!-- <ion-toggle
            #toggle
            [checked]="isOptedIn"
            [disabled]="isToggleDisabled"
            (ionChange)="handleStatusToggleClick($event)"
            class="status-toggle">
          </ion-toggle> -->
          <ion-toggle
            #toggle
            [checked]="isOptedIn"
            [disabled]="isToggleDisabled"
            (ionChange)="handleStatusToggleClick($event)"
            class="status-toggle"
            slot="end">
          </ion-toggle>
          <ion-icon
            name="chevron-forward-outline"
            class="arrow-icon"
            [ngClass]="{'opted-in': isOptedIn}"
            (click)="handleSignatureClick($event)"
            slot="end">
          </ion-icon>
        </div>
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col size="4">
        <div class="display-grid">
          <ion-text class="child-item-label">{{ 'OPTED_OUT_DATE' | translate }}</ion-text>
          <ion-label class="child-item-text">{{ optedOutDate }}</ion-label>
        </div>
      </ion-col>
      <ion-col size="4">
        <div class="display-grid">
          <ion-text class="child-item-label">{{ 'OPTED_OUT_SOURCE' | translate }}</ion-text>
          <ion-label class="child-item-text">{{ optedOutSource }}</ion-label>
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>
<!-- </ion-item> -->

